import RaicheSignUpContainer from "../../../raicheComponents/raicheSignUpContainer/RaicheSignUpContainer";
import React from "react"
import style from "./IntroductionVideo.module.scss"
import VideoJSPlayer from "../../../raikoComponents/videoJSPlayer/VideoJSPlayer";
import {RaikoButtonPrimary, RaikoFlexAlignEnd} from "@moeindal/base-raiko-panel-components";


export default function IntroductionVideo() {
    // const playerRef = React.useRef(null);
    //
    // const videoJsOptions = {
    //     poster: true,
    //     autoplay: true,
    //     controls: true,
    //     responsive: true,
    //     fluid: true,
    //     muted: true,
    //     sources: [{
    //         poster: "https://news-cdn.varzesh3.com/pictures/2023/08/15/A/3yre30mq.jpg?w=800",
    //         src: "https://media.w3.org/2010/05/sintel/trailer_hd.mp4",
    //         type: 'video/mp4'
    //     }]
    // };
    //
    // const handlePlayerReady = (player) => {
    //     playerRef.current = player;
    //
    //     // You can handle player events here, for example:
    //     player.on('waiting', () => {
    //
    //     });
    //
    //     player.on('dispose', () => {
    //     });
    // };
    const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        poster: true,
        sources: [{
            src: 'https://www.tutorialspoint.com/videos/sample480.mp4',
            type: 'video/mp4',
            poster: 'https://www.tutorialspoint.com/reactjs/images/reactjs-mini-logo.jpg'
        }]
    };
    return (
        <RaicheSignUpContainer>
            {/*<video className={css`width: 100%`} width="320" height="240" controls>*/}
            {/*    <source src={fakeVideo} type="video/mp4"/>*/}
            {/*</video>*/}

            {/*<RaikoVideoJS options={videoJsOptions} onReady={handlePlayerReady}/>*/}
            <VideoJSPlayer {...videoJsOptions} />
            <p className={style.description}>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از
                طراحان گرافیک است چاپگرها و
                متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز</p>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={"ثبت"}/>
            </RaikoFlexAlignEnd>

        </RaicheSignUpContainer>
    )
}